import { render, staticRenderFns } from "./TankCharges.vue?vue&type=template&id=788fb24a&"
import script from "./TankCharges.vue?vue&type=script&lang=js&"
export * from "./TankCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports